import React, { Fragment } from 'react';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import FolioPageContain from '../../Component/Folio';

const FolioPage = ({ pageName }) => (
  <Fragment>
    <Breadcrumbs parent="Pages" title="Folio" />
    <FolioPageContain pageName={pageName}/>
  </Fragment>
);
export default FolioPage;
